import { render, staticRenderFns } from "./BtnAtualizarRecursoRM.vue?vue&type=template&id=a4b6e15e"
import script from "./BtnAtualizarRecursoRM.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarRecursoRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports